"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generalize = exports.tupleScheme = exports.arrayScheme = exports.polymorphicScheme = exports.functionScheme = exports.instantiate = exports.typeVarGenerator = exports.NameError = void 0;
const util_1 = require("../../util");
const builders_1 = require("../types/builders");
const substitution_1 = require("../substitution");
const helpers_1 = require("../types/helpers");
class NameError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.NameError = NameError;
function typeVarGenerator() {
    let current = 0;
    return function newTypeVar() {
        current += 1;
        return builders_1.typeVar(`t${current}`);
    };
}
exports.typeVarGenerator = typeVarGenerator;
function instantiate(scheme, uniqueTypeVar = typeVarGenerator()) {
    const sub = [...scheme.bound].reduce((sub, oldName) => ({ ...sub, [oldName]: uniqueTypeVar() }), substitution_1.EMPTY_SUBSTITUTION);
    return substitution_1.substituteInType(sub, scheme.type);
}
exports.instantiate = instantiate;
function functionScheme(type1, type2, ...types) {
    return generalize({}, builders_1.functionType(type1, type2, ...types));
}
exports.functionScheme = functionScheme;
function polymorphicScheme(constructor, parameters) {
    return generalize({}, builders_1.polymorphicType(constructor, parameters));
}
exports.polymorphicScheme = polymorphicScheme;
function arrayScheme(type) {
    return generalize({}, builders_1.arrayType(type));
}
exports.arrayScheme = arrayScheme;
function tupleScheme(...types) {
    return generalize({}, builders_1.tupleType(...types));
}
exports.tupleScheme = tupleScheme;
function generalize(context, type) {
    const freeVars = util_1.difference(builders_1.freeTypeVars(type), helpers_1.freeTypeVarsContext(context));
    return humanFriendlyScheme({
        bound: freeVars,
        type,
    });
}
exports.generalize = generalize;
function humanFriendlyScheme(scheme) {
    const newTypeVar = typeVarGenerator();
    const renamingSubstitution = [...scheme.bound].reduce((acc, varName) => ({ ...acc, [varName]: newTypeVar() }), substitution_1.EMPTY_SUBSTITUTION);
    const renamedBoundVariables = new Set([...scheme.bound].map(varName => renamingSubstitution[varName].name));
    return {
        bound: renamedBoundVariables,
        type: substitution_1.substituteInType(renamingSubstitution, scheme.type),
    };
}
//# sourceMappingURL=helpers.js.map